import React from 'react';
import { Box, Stack, TextField, Typography } from '@mui/material';
import BuySellAccountPicker from './BuySellAccountPicker.jsx';

const BuySellAccountLookup = ({
  searchOptions,
  searchLoading,
  searchInputValue,
  onSearchInputValueChange,
  onSearchQueryChange,
  selectedAccount,
  onAccountChange,
  purchasingSearchOptions,
  purchasingSearchLoading,
  purchasingSearchInputValue,
  onPurchasingSearchInputValueChange,
  onPurchasingSearchQueryChange,
  purchasingAccount,
  onPurchasingAccountChange,
  buySellAccountId,
  onBuySellAccountIdChange,
  purchasingBAC,
  onPurchasingBACChange,
}) => (
  <>
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 0.75 }}>
        Find selling account
      </Typography>
      <BuySellAccountPicker
        label="Search (BAC, name, or address)"
        placeholder="Example: 123456 or Metro Auto Group"
        helperText="Searches the AppSheet Salesforce Accounts cache."
        searchOptions={searchOptions}
        searchLoading={searchLoading}
        inputValue={searchInputValue}
        onInputValueChange={onSearchInputValueChange}
        onSearchQueryChange={onSearchQueryChange}
        selectedAccount={selectedAccount}
        onAccountChange={onAccountChange}
      />
    </Box>

    <Box>
      <Typography variant="subtitle2" sx={{ mb: 0.75 }}>
        Find purchasing account
      </Typography>
      <BuySellAccountPicker
        label="Search purchasing account"
        placeholder="Example: Summit Chevy South"
        helperText="Selecting an account sets the Purchasing Salesforce Account ID."
        searchOptions={purchasingSearchOptions}
        searchLoading={purchasingSearchLoading}
        inputValue={purchasingSearchInputValue}
        onInputValueChange={onPurchasingSearchInputValueChange}
        onSearchQueryChange={onPurchasingSearchQueryChange}
        selectedAccount={purchasingAccount}
        onAccountChange={onPurchasingAccountChange}
      />
    </Box>

    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextField
        fullWidth
        label="Account name"
        value={selectedAccount?.accountName || ''}
        InputProps={{ readOnly: true }}
      />
      <TextField
        fullWidth
        label="Selling Salesforce Account ID"
        value={selectedAccount?.accountId || ''}
        InputProps={{ readOnly: true }}
      />
    </Stack>

    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextField
        fullWidth
        label="Selling BAC"
        value={selectedAccount?.bac || ''}
        InputProps={{ readOnly: true }}
      />
      <TextField
        fullWidth
        label="Purchasing Salesforce Account ID"
        value={buySellAccountId}
        onChange={(event) => onBuySellAccountIdChange(event.target.value)}
      />
    </Stack>

    <TextField
      fullWidth
      label="Purchasing BAC"
      value={purchasingBAC}
      onChange={(event) => onPurchasingBACChange(event.target.value)}
      helperText="Optional fallback BAC used when the selling account no longer has one."
    />
  </>
);

export default BuySellAccountLookup;
